import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { boardFocusAreas } from '../data/boardFocus';
export function BoardPositioning() {
  return <section id="board" className="bg-navy py-24 lg:py-32" data-id="element-44" data-mp="1lx0c4qi1x6sz">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-45" data-mp="1lvgxf4c1n3tb">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-start" data-id="element-46" data-mp="1qpblsl2lg6yq">
          <SectionHeading eyebrow="04. Board Positioning" title="Positioned for Board-Level Impact" description="Bringing an international executive perspective to board, advisory and senior leadership environments where growth, transformation, governance and long-term value creation need to be balanced with disciplined execution." tone="light" data-id="element-47" data-mp="1uqdhirxay0vy" />

          <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10" data-id="element-48" data-mp="aasaydcimt6y">
            {boardFocusAreas.map((area, index) => {
            const Icon = area.icon;
            return <motion.div key={area.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              ease: [0.23, 1, 0.32, 1],
              delay: index * 0.06
            }} className="bg-navy p-8" data-id="element-49" data-mp="1o9jgsydl3f1n" data-mpi={index}>
                  <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} data-id="element-50" data-mp="277m2b36xatup" />
                  <h3 className="mt-4 font-serif text-lg font-semibold text-white" data-id="element-51" data-mp="2289dwe0eleq0">{area.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400" data-id="element-52" data-mp="1x968gsgih6hi">{area.description}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}